namespace GeniuzPOS.QRreport {
    export interface QRywcSpecAdvpro1001Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        PromoCampaign: Serenity.LookupEditor;
        PmGroupId: Serenity.LookupEditor;
        ShopId: Serenity.LookupEditor;
    }

    export class QRywcSpecAdvpro1001Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecAdvpro1001';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecAdvpro1001Form.init)  {
                QRywcSpecAdvpro1001Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(QRywcSpecAdvpro1001Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'PromoCampaign', w0,
                    'PmGroupId', w0,
                    'ShopId', w0
                ]);
            }
        }
    }
}
